import React from 'react';
import './App.css';
import { RingLoader } from 'react-spinners';

function App() {

  const height = window.innerHeight;

  return (
    <div className="App">
      <meta http-equiv="refresh" content="1; URL='https://shapeportal.shinyapps.io/SHAPE/'" />
      <header className="App-header">
        <RingLoader size={height/3} color='white' />
        
        <p style={{marginTop:'10vh',fontSize:'2em'}}>
          OPENING THE <a id='hover' style={{color:'#f5aa42',textDecoration:'none',fontWeight:'bold'}} href='https://shapeportal.shinyapps.io/SHAPE/' target='_blank' rel="noreferrer">SHAPE PORTAL</a>
        </p>
        <p style={{marginTop:'-5vh'}}>
          (this may take a moment)
        </p>
      </header>
    </div>
  );
}

export default App;
